import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import {
  Header,
  Footer,
  ImgGirl
} from "~/components/blocks";

import {
  HeroBanner,
  Winners
} from "~/components/sections";

import { scrollTop } from "~/utils/tools";


export default function PromotionWinners() {
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };

  const animations = {
    exit: { y: "auto", opacity: 0, transition },
    enter: {
      y: "auto",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) {
      scrollTop();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title>Bebê Johnson's | Home</title>
        <meta name="description" content="Promoção Bebê Johnson's" />
      </Helmet>
      <Header />
      <HeroBanner />
      <motion.div
        variants={animations}
        className="single"
        initial="exit"
        animate="enter"
        exit="exit"
      >
        <Winners />
        <div>
          <ImgGirl />
        </div>
      </motion.div>
      <Footer />
    </>
  );
}
